import { useMutation } from '@tanstack/react-query';

import { exportPartyToBrio } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

export default function useExportPartyToBrio() {
  return useMutation({
    mutationFn: ({ partyId }: { partyId: string }) =>
      exportPartyToBrio(
        {
          params: {
            path: { party_id: partyId },
            query: {},
          },
        },
        wgApi,
      ),
  });
}
